/**
 * Single source of truth for JC3 Wealth Legacy Group business identity.
 *
 * Every footer, invoice, email template, and contact display in the admin
 * dashboard MUST read from this module. If you find a hardcoded phone
 * number, address, email, or firm name in a .jsx file, replace it with
 * `BUSINESS.*` from here.
 */
export const BUSINESS = {
  legalName:     "JC3 Wealth Legacy Group LLC",
  shortName:     "JC3 Wealth Legacy Group",
  addressLine1:  "8735 Dunwoody Place",
  addressLine2:  "Suite 8350",
  city:          "Atlanta",
  state:         "GA",
  postalCode:    "30350",
  phone:         "470-888-7331",
  email:         "jace@jc3wealthlegacy.com",
  website:       "jc3wealthlegacy.com",
  websiteUrl:    "https://jc3wealthlegacy.com",
  tagline:       "Build Wealth. Protect Legacy. Own Your Future.",
  dashboardName: "Executive Command Center",
};

export const addressSingleLine = () =>
  `${BUSINESS.addressLine1}, ${BUSINESS.addressLine2}, ${BUSINESS.city}, ${BUSINESS.state} ${BUSINESS.postalCode}`;

export const footerLine = () =>
  `© 2026 ${BUSINESS.legalName} · ${BUSINESS.tagline}`;
